import AssignmentGeneratorView from "@features/assignments/AssignmentGenerator/view";

const AssignmentGenerator = () => {
  return <AssignmentGeneratorView />;
};

export default AssignmentGenerator;
